import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { INDUSTRIES } from "../../data/site";

export const IndustriesSection = () => {
  const [active, setActive] = useState(0);
  const ind = INDUSTRIES[active];

  return (
    <section data-testid="industries-section" className="relative bg-[#FFFFFF] py-24 md:py-32 border-t border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-14">
          <div className="eyebrow mb-4">// Industries Served · 03</div>
          <h2 className="font-display uppercase tracking-tight text-slate-900 text-4xl md:text-6xl leading-[0.95] max-w-3xl">
            Trusted across the<br /><span className="text-[#0EA5E9]">world's critical</span> industries
          </h2>
        </div>

        <div className="grid md:grid-cols-12 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
          {/* List */}
          <div className="md:col-span-5 bg-[#FFFFFF]">
            {INDUSTRIES.map((i, idx) => {
              const isActive = idx === active;
              return (
                <button
                  key={i.id}
                  onMouseEnter={() => setActive(idx)}
                  onFocus={() => setActive(idx)}
                  onClick={() => setActive(idx)}
                  data-testid={`industry-tab-${i.id}`}
                  className={`w-full text-left flex items-center justify-between gap-4 px-6 py-5 border-b border-[#F1F5F9] transition-colors ${
                    isActive ? "bg-[#F8FAFC]" : "hover:bg-[#F8FAFC]"
                  }`}
                >
                  <div className="flex items-center gap-5">
                    <span className={`font-mono-wm text-xs tracking-[0.25em] ${isActive ? "text-[#0EA5E9]" : "text-[#64748B]"}`}>
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    <div>
                      <div className={`font-display uppercase tracking-tight text-lg md:text-xl ${isActive ? "text-slate-900" : "text-[#475569]"}`}>
                        {i.name}
                      </div>
                      <div className="text-xs text-[#64748B]">{i.short}</div>
                    </div>
                  </div>
                  <ChevronRight className={`w-4 h-4 ${isActive ? "text-[#0EA5E9]" : "text-[#E2E8F0]"}`} />
                </button>
              );
            })}
          </div>

          {/* Visual */}
          <div className="md:col-span-7 bg-[#FFFFFF] relative min-h-[420px] md:min-h-0">
            <AnimatePresence mode="wait">
              <motion.div
                key={ind.id}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.45 }}
                className="absolute inset-0"
              >
                <img src={ind.image} alt={ind.name} className="w-full h-full object-cover" />
                <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
                  <div className="bg-white border-l-2 border-[#0EA5E9] p-6 md:p-8 shadow-[0_18px_40px_-16px_rgba(15,23,42,0.25)] max-w-md">
                    <div className="font-mono-wm text-[10px] tracking-[0.3em] uppercase text-[#0EA5E9] mb-2">
                      Industry · {String(active + 1).padStart(2, "0")}
                    </div>
                    <h3 className="font-display uppercase tracking-tight text-[#0F172A] text-2xl md:text-3xl mb-3">{ind.name}</h3>
                    <ul className="space-y-1.5">
                      {ind.bullets.map((b) => (
                        <li key={b} className="flex items-center gap-3 text-sm text-[#334155]">
                          <span className="w-3 h-px bg-[#0EA5E9]" />
                          {b}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
